import 'bootstrap/dist/css/bootstrap.css';
import React,{Component} from "react";
import './styles.css';
class FeatFound extends Component{


  state = {animate: false}
  componentDidMount() {
    this.animateComponent();
    window.addEventListener('scroll', this.handleScroll);
    //this.component.classList.remove('hidden');
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.found[0] !== this.props.found[0]) {
      // Remove the animation class when changing the artist
      this.removeAnimation();

      // Set a timeout to add the animation class after a short delay
      setTimeout(() => {
        this.animateComponent();
      }, 100); // You can adjust the delay time as needed
    }
  }

  animateComponent() {
    // Set the state to enable animation
    this.setState({ animate: true });
  }

  removeAnimation() {
    // Set the state to disable animation
    this.setState({ animate: false });
  }

  handleScroll = () => {
    const { onFooterPosition } = this.props;
    const tableContainer = this.component; // Update the reference to the component itself

    if (tableContainer) {
      // Ensure tableContainer is defined
      const scrollPosition = tableContainer.scrollTop;
      const contentHeight = tableContainer.scrollHeight;
      const containerHeight = tableContainer.clientHeight;

      // Determine whether the footer should be fixed or not
      const shouldFooterBeFixed = scrollPosition + containerHeight >= contentHeight;

      onFooterPosition(shouldFooterBeFixed); // Signal the parent to update the footer position
    }
  };

  formatMilliseconds = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
  
    // Use conditional (ternary) operator to remove leading zero if minutes < 10
    const formattedMinutes = minutes < 10 ? String(minutes) : String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');
  
    return `${formattedMinutes}:${formattedSeconds}`;
  };
  
  
    render(){
      const { animate } = this.state;
      const { found } = this.props;
      //console.log("found", found)
        return(
            <div className={`fadein ${animate ? 'animate' : ''}`} key={this.props.found[0]} ref={(component) => (this.component = component)}>
            <table className="table table-dark table-hover" style={{cursor: 'pointer', borderColor: "#D9E724", textAlign: "center", verticalAlign: "middle", marginTop: "5px"}}>
              <thead style={{borderColor: '#8b008b'}}>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Title</th>
                  <th scope="col">Author</th>
                  <th scope="col">Length</th>
                </tr>
              </thead>
              <tbody>
                {found.map((result, index) => (
                  <tr key={result.id} onClick={() => { window.location.replace(result.external_urls.spotify) }}>
                    <td>
                      <img
                          src={result.img}
                          alt={result.name}
                          style={{ width: '47.5px', height: '47.5px' }} // Imposta la larghezza desiderata in pixel
                      />
                </td>
                    <td>{result.name}</td>
                    <td>{result.artists[0].name}</td>
                    <td>{this.formatMilliseconds(result.duration_ms)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
        )
    }
}

export default FeatFound;